import { useNumberFormatter } from "react-aria";

import type { Currency } from "../currencies/types";
import { Currencies } from "../currencies/types";

export function useFormatCurrency(currency = "USD", options = {}) {
	const c: Currency = (Currencies[currency.toUpperCase()] || Currencies.USD)!;

	return useNumberFormatter({
		style: "currency",
		currency: c.code || "USD",
		minimumFractionDigits: c.decimalPlaces,
		maximumFractionDigits: c.decimalPlaces,
		currencyDisplay: "narrowSymbol",
		...options,
	});
}
